// Central-difference gradient angle. Marks that need an orientation (ticks,
// flow lines) and advected particles both steer by this, so it lives once here
// rather than in every field module.
const EPS = 0.012

export function gradientAngle(sample, x, y, t) {
  const gx = sample(x + EPS, y, t) - sample(x - EPS, y, t)
  const gy = sample(x, y + EPS, t) - sample(x, y - EPS, t)
  return Math.atan2(gy, gx)
}
